module.exports = __webpack_public_path__ + "media/images/open_in_new_green-50f7cc21c7e0a9c87876d41a078ac057.svg";